import React from 'react';
import styled from 'astroturf/react';
import NavbarSearchContent, { JournalOption } from './NavbarSearchContent';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 16px;
  class-name: standalone-search-container;
`;

interface StandaloneSearchContainerProps {
  initialQuery?: string;
  initialJournal?: { slug: string; name: string };
  journalOptions?: JournalOption[];
}

const StandaloneSearchContainer: React.FC<StandaloneSearchContainerProps> = ({
  initialQuery = '',
  initialJournal,
  journalOptions = [{ id: 'all', name: 'All journals' }],
}) => {
  const initialJournalOption = initialJournal
    ? { id: initialJournal.slug, name: initialJournal.name }
    : { id: 'all', name: 'All journals' };

  return (
    <Container>
      <NavbarSearchContent
        initialQuery={initialQuery}
        initialJournal={initialJournalOption}
        journalOptions={journalOptions}
      />
    </Container>
  );
};

export default StandaloneSearchContainer;
